import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cp-compliance-due-to-expire-notification',
  templateUrl: './compliance-due-to-expire-notification.component.html',
  styleUrls: ['./compliance-due-to-expire-notification.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class ComplianceDueToExpireNotificationComponent {
  constructor(private _router: Router) {}

  public get isNotCompliancePage(): boolean {
    return !this._router.url.startsWith('/compliance');
  }
}
